<!-- 新增收货地址 -->
<template>
  <div class="content-box" id="add-address">
    <!-- header start -->
    <van-nav-bar
      title="新增收货地址"
      fixed
      :placeholder="true"
      :z-index="99"
      left-arrow
      @click-left="goBack"
    />
    <!-- header end -->
    <div>
      <van-field
        v-model="inputInfo.name"
        label="姓名"
        placeholder="收货人姓名"
      />
      <van-field
        v-model="inputInfo.phone"
        type="number"
        label="手机号"
        placeholder="手机号码"
      />
      <van-field
        v-model="inputInfo.areaNames"
        label="所在区域"
        placeholder="请选择所在区域"
        readonly
        is-link
        @click="showArea = true"
      />
      <van-field
        v-model="inputInfo.address"
        label="详细地址"
        placeholder="道路、门牌号、小区、楼"
      />
      <van-cell center title="设为默认地址">
        <template #right-icon>
          <van-switch
            v-model="inputInfo.isDefault"
            size="24"
            active-color="#0684FF"
          />
        </template>
      </van-cell>
    </div>

    <div class="change-btn" @click="addAddress()" tapmode>
      保存地址
    </div>
    <!-- <div
      v-if="judge == 2"
      class="change-btn"
      onclick="updateAddressBtn()"
      tapmode
    >
      确认修改
    </div> -->

    <!-- 省市区弹窗 -->
    <van-popup v-model="showArea" position="bottom" :style="{ height: '45%' }">
      <van-area
        :area-list="areaList"
        @confirm="onAreaConfirm"
        @cancel="showArea = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { Area } from "vant";
import { areaList } from "@vant/area-data";
export default {
  data() {
    return {
      showArea: false,
      address: "选择省、市、区",
      areaList,
      areaRegion: "",
      inputInfo: {
        name: "", //输入名字
        phone: "", //输入电话
        province: "", // 省
        city: "", //市
        county: "", //区
        address: "", //地址
        areaNames: "",
        isDefault: false,
      },
      isGetAddress: false, //获取的地址
      // judge: this.$route.params.judge, //判断是新增还是修改
    };
  },
  components: {
    [Area.name]: Area,
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onAreaConfirm(val) {
      this.showArea = false;
      // this.areaRegion = val;
      var addrInfo = val[0].name + "-" + val[1].name + "-" + val[2].name;
      // this.areaRegion = addrInfo;
      this.inputInfo.areaNames = addrInfo;
    },
    addAddress() {
      if (this.inputInfo.name == "") {
        this.$toast("姓名不能为空！");
        return false;
      }
      if (this.inputInfo.phone == "") {
        this.$toast("手机号不能为空！");
        return false;
      }
      var myreg = /^[1][0-9]{10}$/;
      if (!myreg.test(this.inputInfo.phone)) {
        this.$toast("请输入正常的手机号!");
        return false;
      }
      if (this.inputInfo.areaNames == "") {
        this.$toast("请选择所在区域!");
        return false;
      }
      if (this.inputInfo.address == "") {
        this.$toast("详细地址不能为空！");
        return false;
      }
      Object.assign(this.inputInfo, {
        type: "addAndUpdateAddress"
      });
      var _this = this;
      // console.log(this.inputInfo);
      this.$store.dispatch(this.inputInfo).then((res) => {
        // console.log(res);
        if (res.Result.IsSuccess) {
          _this.$toast(res.Result.Message);
          _this.$router.go(-1);
        } else {
          this.$toast(res.Result.Message);
        }
      });
    },
  },
};
</script>
<style scoped></style>
